import TurndownService from 'turndown';
import { gfm } from 'turndown-plugin-gfm';
import { marked } from 'marked';

// Initialize Turndown for HTML to Markdown conversion
const turndownService = new TurndownService({
  headingStyle: 'atx',
  codeBlockStyle: 'fenced',
  bulletListMarker: '-',
  emDelimiter: '*',
  strongDelimiter: '**',
});

// Add GitHub Flavored Markdown support (tables, strikethrough)
turndownService.use(gfm);

/**
 * Convert Markdown to HTML
 * Used when loading existing notes into the editor
 */
export const markdownToHtml = async (markdown: string): Promise<string> => {
  if (!markdown) return '';
  
  try {
    const html = await marked.parse(markdown, {
      gfm: true,
      breaks: true,
    });
    return html;
  } catch (error) {
    console.error('Error converting markdown to HTML:', error);
    return markdown; // Fallback to original content
  }
};

/**
 * Convert HTML to Markdown
 * Used when saving editor content to the database
 */
export const htmlToMarkdown = (html: string): string => {
  if (!html) return '';
  
  try {
    const markdown = turndownService.turndown(html);
    return markdown;
  } catch (error) {
    console.error('Error converting HTML to markdown:', error);
    return html; // Fallback to original content
  }
};
